import {
	Dialog,
	DialogContent,
	DialogTitle,
	Fab,
	DialogActions,
	Button,
} from "@mui/material";
import { useMemo } from "react";
import { InputGroup, Form } from "react-bootstrap";
import { ContentCopy } from "@mui/icons-material";

type TCopyLinkDialog = {
	onClose: () => unknown;
	open: boolean;
	title: string;
	examLink: string;
	liveTrackerLink?: string;
};

const CopyLinkDialog = (props: TCopyLinkDialog) => {
	const { onClose, open, title, examLink, liveTrackerLink } = props;

	const handleCopyToClipboard = async (copyLink: string) => {
		try {
			await navigator.clipboard.writeText(copyLink);
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<Dialog onClose={onClose} open={open} maxWidth="md" fullWidth={true}>
			<DialogTitle>{title}</DialogTitle>
			<DialogContent>
				<InputGroup className="mb-3">
					<Form.Control
						type="text"
						readOnly={true}
						value={examLink}
					/>
					<Fab
						aria-label="copy-to-clip"
						onClick={() => handleCopyToClipboard(examLink)}
					>
						<ContentCopy />
					</Fab>
				</InputGroup>
				{liveTrackerLink && (
					<InputGroup className="mb-3">
						<Form.Control
							type="text"
							readOnly={true}
							value={liveTrackerLink}
						/>
						<Fab
							aria-label="copy-to-clip"
							onClick={() =>
								handleCopyToClipboard(liveTrackerLink)
							}
						>
							<ContentCopy />
						</Fab>
					</InputGroup>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Close</Button>
			</DialogActions>
		</Dialog>
	);
};

export default CopyLinkDialog;
